/**
 * The wire shapes of `Rws.AiInsights.Host.Administration`'s provider write-enable endpoints (AIA-109 phase 7): one
 * write-enable switch per vendor (`TD-22`, as amended). Both are gated on `settings.write`. A provider with no writer
 * (`hasWriter` false) cannot be switched on; the PUT answers 404 for it.
 */
import { adminRequest, type AdminResult } from "./adminApi";

/** One vendor's write-enable state. `updatedAt` is null until an administrator has set it. */
export interface ProviderWriteEnable {
  vendorId: string;
  displayName: string;
  hasWriter: boolean;
  writesEnabled: boolean;
  updatedAt: string | null;
}

const providerWriteEnablePath = "/api/providers/write-enable";

/** Calls `GET /api/providers/write-enable`: every vendor in the catalogue and whether its writes are enabled. */
export async function fetchProviderWriteEnable(): Promise<AdminResult<ProviderWriteEnable[]>> {
  return adminRequest<ProviderWriteEnable[]>(providerWriteEnablePath, { method: "GET" }, "provider write-enable");
}

/** Calls `PUT /api/providers/{vendorId}/write-enable` with `{ enabled }`, and returns the vendor's state as saved. */
export async function updateProviderWriteEnable(vendorId: string, enabled: boolean): Promise<AdminResult<ProviderWriteEnable>> {
  return adminRequest<ProviderWriteEnable>(
    `/api/providers/${encodeURIComponent(vendorId)}/write-enable`,
    { method: "PUT", body: JSON.stringify({ enabled }) },
    "provider write-enable update",
  );
}
